@if ((responsiveService.isMobileScreen$ | async) === false) {
  <app-mat-resizeable-panel [minWidth]="60" [maxWidth]="80" class="h-100">
    <!-- Map -->
    <div class="h-100" slot-main>
      <ng-container *ngTemplateOutlet="mapFragment"></ng-container>
    </div>
    <!-- Story details -->
    <div slot-sidebar class="story-details" style="background-color:#fefbf2">
      <!-- Navigation -->
      <ng-container *ngTemplateOutlet="storyFragment"></ng-container>
    </div>
  </app-mat-resizeable-panel>
} @else {
  <div class="story-details" style="background-color:#fefbf2">
    <ng-container *ngTemplateOutlet="storyFragment"></ng-container>
    <ng-container *ngTemplateOutlet="mapFragment"></ng-container>
  </div>
}


<ng-template #mapFragment>
  <google-map
    [height]="(responsiveService.isMobileScreen$ | async)? '80%' : '100%'"
    width="100%"
    [options]="mapOptions"
    [center]="mapCenter"
    (mapClick)="closeInfoWindow()"
    (mapInitialized)="centerMapToMarkers()"
  >
    @for (marker of markerList; track marker) {
      <map-marker
        #markerRef="mapMarker"
        [position]="marker.position"
        [options]="marker.options"
        (mapMouseover)="openInfoWindow(markerRef, marker)"
      ></map-marker>
    }

    <map-info-window>
      <div style="padding:8px;max-width:260px">
        @if (infoWindowStory.headerImage.imageUrl) {
          <img
            [src]="infoWindowStory.headerImage.imageUrl"
            [alt]="infoWindowStory.title"
            style="width:100%;height:96px;object-fit:cover;border-radius:4px;margin-bottom:8px"
          />
        }
        <h3 style="font-weight:600;font-size:14px;margin:0 0 4px;color:#333">{{ infoWindowStory.title }}</h3>
        @for (theme of infoWindowStory.themeList; track theme.id) {
          <span style="font-size:10px;background:#fce7f3;color:#be185d;padding:2px 8px;border-radius:12px">
            {{ theme.name }}
          </span>
        }
        @if (infoWindowStory.shortDescription) {
          <p style="font-size:12px;color:#555;">
            {{ infoWindowStory.shortDescription.length > 120 ? infoWindowStory.shortDescription.slice(0, 120) + '…' : infoWindowStory.shortDescription }}
          </p>
        }
        @if (infoWindowStory.id !== storyId) {
          <div class="w-100 d-flex justify-content-end mt-1">
            <button
              [routerLink]="'/story/'+infoWindowStory.url"
              matButton="outlined"
            >
              @if (infoWindowStory.isProject) {
                Project bekijken
              } @else {
                Verhaal bekijken
              }
            </button>
          </div>
        }
      </div>
    </map-info-window>
  </google-map>
</ng-template>

<ng-template #storyFragment>
  <div class="p-3">
    <div
      class="w-100 d-flex justify-content-between mb-2 gap-2"
      [ngClass]="{'flex-column': responsiveService.isMobileScreen$ | async}"
    >
      <div class="cursor--pointer" routerLink="/story-list">← Terug naar overzicht</div>
      <div class="d-flex gap-1 flex-wrap align-items-center">
        <mat-chip-set aria-label="Theme list">
          @for (theme of story.themeList; track theme.id) {
            <mat-chip class="story-theme">{{ theme.name || '-' }}</mat-chip>
          }
        </mat-chip-set>
        @for (tag of story.tagList; track tag.id) {
          <mat-chip class="story-tag">
            <span class="text-primary">{{ tag.name }}</span>
          </mat-chip>
        }
      </div>
    </div>
    <!-- Story body -->
    @if (storyLoaded) {
      <div class="story-body">
        <!-- Title -->
        <h1 class="arbutus text-primary p-0 m-0 mb-4" style="font-size: 2.25rem;">{{ story.title }}</h1>
        <!-- Header image -->
        @if (story.headerImage.imageUrl.length > 0) {
          <mat-card class="mb-3">
            <img
              mat-card-image
              [src]="story.headerImage.imageUrl"
              [alt]="story.headerImage.name"
            />
          </mat-card>
        }
        <!-- Carousel -->
        @if (story.carouselImages.length > 0) {
          <div
            class="carousel-images"
            [ngClass]="(responsiveService.isMobileScreen$ | async)? 'mb-2' : 'mb-4'"
          >
            @for (image of story.carouselImages; track image.id) {
              <mat-card class="carousel-card" (click)="openGalleryDialog(image.id)">
                <img
                  class="carousel-image"
                  mat-card-image
                  [src]="image.imageUrl"
                  [alt]="image.name"
                />
              </mat-card>
            }
          </div>
        }
        <div
          class="w-100 d-flex flex-row justify-content-between mb-2"
          [ngClass]="{'flex-column gap-3': responsiveService.isMobileScreen$ | async}"
        >
          <!-- Story section controls -->
          <div
            class="d-flex gap-2"
            [ngClass]="{'flex-column': responsiveService.isMobileScreen$ | async}"
          >
            <button [ngClass]="{'story-section-active': storySectionStepper.selectedIndex === 0}" matButton="outlined"
                    (click)="showStoryDetail(0)">
              <mat-icon>article</mat-icon>
              Verhaal
            </button>
            @if (story.audioLinks.length > 0) {
              <button [ngClass]="{'story-section-active': storySectionStepper.selectedIndex === 1}" matButton="outlined"
                      (click)="showStoryDetail(1)">
                <mat-icon>audio_file</mat-icon>
                Audio
              </button>
            }
            @if (story.videoLinks.length > 0) {
              <button [ngClass]="{'story-section-active': storySectionStepper.selectedIndex === 2}" matButton="outlined"
                      (click)="showStoryDetail(2)">
                <mat-icon>videocam</mat-icon>
                Video
              </button>
            }
            @if (story.linkList.length > 0 || story.relatedStoryList.length > 0) {
              <button [ngClass]="{'story-section-active': storySectionStepper.selectedIndex === 3}" matButton="outlined"
                      (click)="showStoryDetail(3)">
                <mat-icon>link</mat-icon>
                Gerelateerd
              </button>
            }
            @if (platform.ANDROID || platform.IOS) {
              <button matButton="outlined" (click)="openNavigationOptions()">
                <mat-icon fontSet="material-symbols-outlined">footprint</mat-icon>
                Route
              </button>
            }
          </div>
          <!-- Story information -->
          <div
            class="d-flex gap-2"
            [ngClass]="{'flex-column': responsiveService.isTabletScreen$ | async}"
          >
            <span class="text-primary d-flex justify-content-center align-items-center">
              <mat-icon fontSet="material-symbols-outlined">
                location_on
              </mat-icon>&nbsp;{{ story.neighbourhood.name }}
            </span>
            @if (story.storyDate) {
              <span class="text-primary d-flex justify-content-center align-items-center">
                <mat-icon fontSet="material-symbols-outlined">
                  calendar_today
                </mat-icon>&nbsp;{{ story.storyDate | storyDate }}
              </span>
            }
            <span class="text-primary d-flex justify-content-center align-items-center">
                <mat-icon fontSet="material-symbols-outlined">
                  tag
                </mat-icon>{{ story.collectionNumber }}
              </span>
          </div>
        </div>

        <mat-stepper
          ngSkipHydration
          #storySectionStepper
          class="story-details-stepper stepper--headless stepper--p-0"
          linear="false"
        >
          <!-- Text -->
          <mat-step>
            <div class="text-primary" [innerHTML]="story.story">
            </div>
          </mat-step>
          <!-- Audio -->
          <mat-step>
            @for (audio of story.audioLinks; track audio.id) {
              <h2 class="text-primary my-2">{{ audio.meta.title }}</h2>
              <p class="text-primary  my-2">{{ audio.meta.description }}</p>
              <div>
                <audio controls [src]="audio.url" class="w-100"></audio>
              </div>
            }
          </mat-step>
          <!-- Video -->
          <mat-step>
            <div class="d-flex flex-column gap-3">
              @for (video of story.videoLinks; track video.url) {
                <div class="w-100">
                  <h2 class="text-primary my-2">{{ video.meta.videoTitle }}</h2>
                  <p class="text-primary my-2">{{ video.meta.description }}</p>
                  <youtube-player style="width:100%; display: block;" [videoId]="videoIdFromUrl(video.url)"/>
                </div>
              }
            </div>
          </mat-step>
          <!-- Related to this story -->
          <mat-step>
            <div class="w-100 d-flex flex-row flex-wrap gap-2">
              <!-- External link -->
              @if (story.linkList.length > 0) {
                <mat-card class="story-card flex-grow-1">
                  <mat-card-header>
                    <div class="arbutus text-primary mb-3">Externe links</div>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="d-flex flex-column gap-3">
                      @for (externalLink of story.linkList; track externalLink.url) {
                        <div>
                          <mat-card class="story-card p-3">
                            <a target="_blank" rel="noopener noreferrer" class="text-quaternary"
                               [href]="externalLink.url">{{ externalLink.title }}</a>
                          </mat-card>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }

              <!-- Related stories -->
              @if (story.relatedStoryList.length > 0) {
                <mat-card class="story-card flex-grow-1">
                  <mat-card-header>
                    <div class="arbutus text-primary mb-3">Gerelateerde verhalen</div>
                  </mat-card-header>
                  <mat-card-content>
                    <div class="d-flex flex-column gap-3">
                      @for (relatedStory of story.relatedStoryList; track relatedStory.id) {
                        <div>
                          <mat-card class="story-card p-3">
                            <a [routerLink]="'/story/'+relatedStory.url" rel="noopener noreferrer"
                               class="text-quaternary">{{ relatedStory.title }}</a>
                          </mat-card>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }

            </div>
          </mat-step>
        </mat-stepper>
      </div>
    }
  </div>
</ng-template>
